"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationSettingType = void 0;
/* eslint-disable require-jsdoc */
const constants_1 = require("../constants");
class ApplicationSettingType {
    constructor(userId, studySetting) {
        this.debugMode = false;
        this.contentReviewMode = false;
        this.userId = userId;
        this.studySetting = studySetting;
    }
    static defaultApplicationSetting(userId) {
        const studySetting = {
            duration: 2,
            difficulty: 2,
            soundEffect: true,
            animation: true
        };
        const setting = new ApplicationSettingType(userId, studySetting);
        setting.debugMode = false;
        setting.contentReviewMode = false;
        return setting;
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_APPLICATION_SETTING;
    }
}
exports.ApplicationSettingType = ApplicationSettingType;
